import { configureStore } from '@reduxjs/toolkit';
import {
  AuthAPI, EmailAPI, PaymentMethodAPI, PropertyAPI, PurchaseAPI, UserAPI, WishlistAPI
} from '../services';
import authSlice from '../slices/auth.slice';
import propertySlice from '../slices/property.slice';

export const store = configureStore({
  reducer: {
    [AuthAPI.reducerPath]: AuthAPI.reducer,
    [UserAPI.reducerPath]: UserAPI.reducer,
    [PropertyAPI.reducerPath]: PropertyAPI.reducer,
    [PurchaseAPI.reducerPath]: PurchaseAPI.reducer,
    [WishlistAPI.reducerPath]: WishlistAPI.reducer,
    [EmailAPI.reducerPath]: EmailAPI.reducer,
    [PaymentMethodAPI.reducerPath]: PaymentMethodAPI.reducer,
    auth: authSlice,
    property: propertySlice,
  },
  //@ts-ignore
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat([
    AuthAPI.middleware,
    UserAPI.middleware,
    PropertyAPI.middleware,
    PurchaseAPI.middleware,
    WishlistAPI.middleware,
    EmailAPI.middleware,
    PaymentMethodAPI.middleware,
  ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;